/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SpotlightRouteImport } from './routes/spotlight'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as AppLivesheetRouteImport } from './routes/_app/livesheet'
import { Route as AppLivesheetIndexRouteImport } from './routes/_app/livesheet/index'
import { Route as AppLivesheetResultadosRouteImport } from './routes/_app/livesheet/resultados'
import { Route as AppLivesheetMetricasRouteImport } from './routes/_app/livesheet/metricas'
import { Route as AppLivesheetIndicadoresRouteImport } from './routes/_app/livesheet/indicadores'
import { Route as AppLivesheetFlujoRouteImport } from './routes/_app/livesheet/flujo'
import { Route as AppLivesheetBalanceRouteImport } from './routes/_app/livesheet/balance'
import { Route as AppDataIntegrationRouteImport } from './routes/_app/data/integration'
import { Route as AppDashboardValuationRouteImport } from './routes/_app/dashboard/valuation'
import { Route as AppDashboardSpotlightBoardRouteImport } from './routes/_app/dashboard/spotlight-board'
import { Route as AppDashboardResultsRouteImport } from './routes/_app/dashboard/results'
import { Route as AppDashboardMetricsRouteImport } from './routes/_app/dashboard/metrics'
import { Route as AppDashboardFlowRouteImport } from './routes/_app/dashboard/flow'
import { Route as AppDashboardBalanceRouteImport } from './routes/_app/dashboard/balance'
import { Route as AppAskMaraRouteImport } from './routes/_app/ask/mara'
import { Route as AppAccountCreateRouteImport } from './routes/_app/account/create'
import { Route as AppDashboardResultsOtherAccountsRouteImport } from './routes/_app/dashboard/results/other-accounts'
import { Route as AppDashboardResultsIncomeRouteImport } from './routes/_app/dashboard/results/income'
import { Route as AppDashboardResultsHighlightsRouteImport } from './routes/_app/dashboard/results/highlights'
import { Route as AppDashboardResultsExpenseRouteImport } from './routes/_app/dashboard/results/expense'
import { Route as AppDashboardResultsCostRouteImport } from './routes/_app/dashboard/results/cost'
import { Route as AppDashboardMetricsStabilityRouteImport } from './routes/_app/dashboard/metrics/stability'
import { Route as AppDashboardMetricsSolvencyRouteImport } from './routes/_app/dashboard/metrics/solvency'
import { Route as AppDashboardMetricsReturnRouteImport } from './routes/_app/dashboard/metrics/return'
import { Route as AppDashboardMetricsMarginRouteImport } from './routes/_app/dashboard/metrics/margin'
import { Route as AppDashboardMetricsManagementRouteImport } from './routes/_app/dashboard/metrics/management'
import { Route as AppDashboardMetricsLiquidityRouteImport } from './routes/_app/dashboard/metrics/liquidity'
import { Route as AppDashboardMetricsHighlightsRouteImport } from './routes/_app/dashboard/metrics/highlights'
import { Route as AppDashboardMetricsGrowthRouteImport } from './routes/_app/dashboard/metrics/growth'
import { Route as AppDashboardMetricsEfficiencyRouteImport } from './routes/_app/dashboard/metrics/efficiency'
import { Route as AppDashboardFlowOperationRouteImport } from './routes/_app/dashboard/flow/operation'
import { Route as AppDashboardFlowInvestmentRouteImport } from './routes/_app/dashboard/flow/investment'
import { Route as AppDashboardFlowHighlightsRouteImport } from './routes/_app/dashboard/flow/highlights'
import { Route as AppDashboardFlowFinancingRouteImport } from './routes/_app/dashboard/flow/financing'
import { Route as AppDashboardBalanceLongTermLiabilitiesRouteImport } from './routes/_app/dashboard/balance/long-term-liabilities'
import { Route as AppDashboardBalanceLongTermAssetsRouteImport } from './routes/_app/dashboard/balance/long-term-assets'
import { Route as AppDashboardBalanceHighlightsRouteImport } from './routes/_app/dashboard/balance/highlights'
import { Route as AppDashboardBalanceCurrentLiabilitiesRouteImport } from './routes/_app/dashboard/balance/current-liabilities'
import { Route as AppDashboardBalanceCurrentAssetsRouteImport } from './routes/_app/dashboard/balance/current-assets'
import { Route as AppDashboardResultsOtherAccountsIndexRouteImport } from './routes/_app/dashboard/results/other-accounts.index'
import { Route as AppDashboardResultsIncomeIndexRouteImport } from './routes/_app/dashboard/results/income.index'
import { Route as AppDashboardResultsExpenseIndexRouteImport } from './routes/_app/dashboard/results/expense.index'
import { Route as AppDashboardResultsCostIndexRouteImport } from './routes/_app/dashboard/results/cost.index'
import { Route as AppDashboardBalanceLongTermLiabilitiesIndexRouteImport } from './routes/_app/dashboard/balance/long-term-liabilities.index'
import { Route as AppDashboardBalanceLongTermAssetsIndexRouteImport } from './routes/_app/dashboard/balance/long-term-assets.index'
import { Route as AppDashboardBalanceCurrentLiabilitiesIndexRouteImport } from './routes/_app/dashboard/balance/current-liabilities.index'
import { Route as AppDashboardBalanceCurrentAssetsIndexRouteImport } from './routes/_app/dashboard/balance/current-assets.index'
import { Route as AppDashboardResultsOtherAccountsCategoryDetailRouteImport } from './routes/_app/dashboard/results/other-accounts.$category.detail'
import { Route as AppDashboardResultsIncomeCategoryDetailRouteImport } from './routes/_app/dashboard/results/income.$category.detail'
import { Route as AppDashboardResultsExpenseCategoryDetailRouteImport } from './routes/_app/dashboard/results/expense.$category.detail'
import { Route as AppDashboardResultsCostCategoryDetailRouteImport } from './routes/_app/dashboard/results/cost.$category.detail'
import { Route as AppDashboardBalanceLongTermLiabilitiesCategoryDetailRouteImport } from './routes/_app/dashboard/balance/long-term-liabilities.$category.detail'
import { Route as AppDashboardBalanceLongTermAssetsCategoryDetailRouteImport } from './routes/_app/dashboard/balance/long-term-assets.$category.detail'
import { Route as AppDashboardBalanceCurrentLiabilitiesCategoryDetailRouteImport } from './routes/_app/dashboard/balance/current-liabilities.$category.detail'
import { Route as AppDashboardBalanceCurrentAssetsCategoryDetailRouteImport } from './routes/_app/dashboard/balance/current-assets.$category.detail'

const SpotlightRoute = SpotlightRouteImport.update({
  id: '/spotlight',
  path: '/spotlight',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AppLivesheetRoute = AppLivesheetRouteImport.update({
  id: '/livesheet',
  path: '/livesheet',
  getParentRoute: () => AppRoute,
} as any)
const AppLivesheetIndexRoute = AppLivesheetIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLivesheetRoute,
} as any)
const AppLivesheetResultadosRoute = AppLivesheetResultadosRouteImport.update({
  id: '/resultados',
  path: '/resultados',
  getParentRoute: () => AppLivesheetRoute,
} as any)
const AppLivesheetMetricasRoute = AppLivesheetMetricasRouteImport.update({
  id: '/metricas',
  path: '/metricas',
  getParentRoute: () => AppLivesheetRoute,
} as any)
const AppLivesheetIndicadoresRoute = AppLivesheetIndicadoresRouteImport.update({
  id: '/indicadores',
  path: '/indicadores',
  getParentRoute: () => AppLivesheetRoute,
} as any)
const AppLivesheetFlujoRoute = AppLivesheetFlujoRouteImport.update({
  id: '/flujo',
  path: '/flujo',
  getParentRoute: () => AppLivesheetRoute,
} as any)
const AppLivesheetBalanceRoute = AppLivesheetBalanceRouteImport.update({
  id: '/balance',
  path: '/balance',
  getParentRoute: () => AppLivesheetRoute,
} as any)
const AppDataIntegrationRoute = AppDataIntegrationRouteImport.update({
  id: '/data/integration',
  path: '/data/integration',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardValuationRoute = AppDashboardValuationRouteImport.update({
  id: '/dashboard/valuation',
  path: '/dashboard/valuation',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardSpotlightBoardRoute =
  AppDashboardSpotlightBoardRouteImport.update({
    id: '/dashboard/spotlight-board',
    path: '/dashboard/spotlight-board',
    getParentRoute: () => AppRoute,
  } as any)
const AppDashboardResultsRoute = AppDashboardResultsRouteImport.update({
  id: '/dashboard/results',
  path: '/dashboard/results',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardMetricsRoute = AppDashboardMetricsRouteImport.update({
  id: '/dashboard/metrics',
  path: '/dashboard/metrics',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardFlowRoute = AppDashboardFlowRouteImport.update({
  id: '/dashboard/flow',
  path: '/dashboard/flow',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardBalanceRoute = AppDashboardBalanceRouteImport.update({
  id: '/dashboard/balance',
  path: '/dashboard/balance',
  getParentRoute: () => AppRoute,
} as any)
const AppAskMaraRoute = AppAskMaraRouteImport.update({
  id: '/ask/mara',
  path: '/ask/mara',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountCreateRoute = AppAccountCreateRouteImport.update({
  id: '/account/create',
  path: '/account/create',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardResultsOtherAccountsRoute =
  AppDashboardResultsOtherAccountsRouteImport.update({
    id: '/other-accounts',
    path: '/other-accounts',
    getParentRoute: () => AppDashboardResultsRoute,
  } as any)
const AppDashboardResultsIncomeRoute =
  AppDashboardResultsIncomeRouteImport.update({
    id: '/income',
    path: '/income',
    getParentRoute: () => AppDashboardResultsRoute,
  } as any)
const AppDashboardResultsHighlightsRoute =
  AppDashboardResultsHighlightsRouteImport.update({
    id: '/highlights',
    path: '/highlights',
    getParentRoute: () => AppDashboardResultsRoute,
  } as any)
const AppDashboardResultsExpenseRoute =
  AppDashboardResultsExpenseRouteImport.update({
    id: '/expense',
    path: '/expense',
    getParentRoute: () => AppDashboardResultsRoute,
  } as any)
const AppDashboardResultsCostRoute = AppDashboardResultsCostRouteImport.update({
  id: '/cost',
  path: '/cost',
  getParentRoute: () => AppDashboardResultsRoute,
} as any)
const AppDashboardMetricsStabilityRoute =
  AppDashboardMetricsStabilityRouteImport.update({
    id: '/stability',
    path: '/stability',
    getParentRoute: () => AppDashboardMetricsRoute,
  } as any)
const AppDashboardMetricsSolvencyRoute =
  AppDashboardMetricsSolvencyRouteImport.update({
    id: '/solvency',
    path: '/solvency',
    getParentRoute: () => AppDashboardMetricsRoute,
  } as any)
const AppDashboardMetricsReturnRoute =
  AppDashboardMetricsReturnRouteImport.update({
    id: '/return',
    path: '/return',
    getParentRoute: () => AppDashboardMetricsRoute,
  } as any)
const AppDashboardMetricsMarginRoute =
  AppDashboardMetricsMarginRouteImport.update({
    id: '/margin',
    path: '/margin',
    getParentRoute: () => AppDashboardMetricsRoute,
  } as any)
const AppDashboardMetricsManagementRoute =
  AppDashboardMetricsManagementRouteImport.update({
    id: '/management',
    path: '/management',
    getParentRoute: () => AppDashboardMetricsRoute,
  } as any)
const AppDashboardMetricsLiquidityRoute =
  AppDashboardMetricsLiquidityRouteImport.update({
    id: '/liquidity',
    path: '/liquidity',
    getParentRoute: () => AppDashboardMetricsRoute,
  } as any)
const AppDashboardMetricsHighlightsRoute =
  AppDashboardMetricsHighlightsRouteImport.update({
    id: '/highlights',
    path: '/highlights',
    getParentRoute: () => AppDashboardMetricsRoute,
  } as any)
const AppDashboardMetricsGrowthRoute =
  AppDashboardMetricsGrowthRouteImport.update({
    id: '/growth',
    path: '/growth',
    getParentRoute: () => AppDashboardMetricsRoute,
  } as any)
const AppDashboardMetricsEfficiencyRoute =
  AppDashboardMetricsEfficiencyRouteImport.update({
    id: '/efficiency',
    path: '/efficiency',
    getParentRoute: () => AppDashboardMetricsRoute,
  } as any)
const AppDashboardFlowOperationRoute =
  AppDashboardFlowOperationRouteImport.update({
    id: '/operation',
    path: '/operation',
    getParentRoute: () => AppDashboardFlowRoute,
  } as any)
const AppDashboardFlowInvestmentRoute =
  AppDashboardFlowInvestmentRouteImport.update({
    id: '/investment',
    path: '/investment',
    getParentRoute: () => AppDashboardFlowRoute,
  } as any)
const AppDashboardFlowHighlightsRoute =
  AppDashboardFlowHighlightsRouteImport.update({
    id: '/highlights',
    path: '/highlights',
    getParentRoute: () => AppDashboardFlowRoute,
  } as any)
const AppDashboardFlowFinancingRoute =
  AppDashboardFlowFinancingRouteImport.update({
    id: '/financing',
    path: '/financing',
    getParentRoute: () => AppDashboardFlowRoute,
  } as any)
const AppDashboardBalanceLongTermLiabilitiesRoute =
  AppDashboardBalanceLongTermLiabilitiesRouteImport.update({
    id: '/long-term-liabilities',
    path: '/long-term-liabilities',
    getParentRoute: () => AppDashboardBalanceRoute,
  } as any)
const AppDashboardBalanceLongTermAssetsRoute =
  AppDashboardBalanceLongTermAssetsRouteImport.update({
    id: '/long-term-assets',
    path: '/long-term-assets',
    getParentRoute: () => AppDashboardBalanceRoute,
  } as any)
const AppDashboardBalanceHighlightsRoute =
  AppDashboardBalanceHighlightsRouteImport.update({
    id: '/highlights',
    path: '/highlights',
    getParentRoute: () => AppDashboardBalanceRoute,
  } as any)
const AppDashboardBalanceCurrentLiabilitiesRoute =
  AppDashboardBalanceCurrentLiabilitiesRouteImport.update({
    id: '/current-liabilities',
    path: '/current-liabilities',
    getParentRoute: () => AppDashboardBalanceRoute,
  } as any)
const AppDashboardBalanceCurrentAssetsRoute =
  AppDashboardBalanceCurrentAssetsRouteImport.update({
    id: '/current-assets',
    path: '/current-assets',
    getParentRoute: () => AppDashboardBalanceRoute,
  } as any)
const AppDashboardResultsOtherAccountsIndexRoute =
  AppDashboardResultsOtherAccountsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardResultsOtherAccountsRoute,
  } as any)
const AppDashboardResultsIncomeIndexRoute =
  AppDashboardResultsIncomeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardResultsIncomeRoute,
  } as any)
const AppDashboardResultsExpenseIndexRoute =
  AppDashboardResultsExpenseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardResultsExpenseRoute,
  } as any)
const AppDashboardResultsCostIndexRoute =
  AppDashboardResultsCostIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardResultsCostRoute,
  } as any)
const AppDashboardBalanceLongTermLiabilitiesIndexRoute =
  AppDashboardBalanceLongTermLiabilitiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardBalanceLongTermLiabilitiesRoute,
  } as any)
const AppDashboardBalanceLongTermAssetsIndexRoute =
  AppDashboardBalanceLongTermAssetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardBalanceLongTermAssetsRoute,
  } as any)
const AppDashboardBalanceCurrentLiabilitiesIndexRoute =
  AppDashboardBalanceCurrentLiabilitiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardBalanceCurrentLiabilitiesRoute,
  } as any)
const AppDashboardBalanceCurrentAssetsIndexRoute =
  AppDashboardBalanceCurrentAssetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardBalanceCurrentAssetsRoute,
  } as any)
const AppDashboardResultsOtherAccountsCategoryDetailRoute =
  AppDashboardResultsOtherAccountsCategoryDetailRouteImport.update({
    id: '/$category/detail',
    path: '/$category/detail',
    getParentRoute: () => AppDashboardResultsOtherAccountsRoute,
  } as any)
const AppDashboardResultsIncomeCategoryDetailRoute =
  AppDashboardResultsIncomeCategoryDetailRouteImport.update({
    id: '/$category/detail',
    path: '/$category/detail',
    getParentRoute: () => AppDashboardResultsIncomeRoute,
  } as any)
const AppDashboardResultsExpenseCategoryDetailRoute =
  AppDashboardResultsExpenseCategoryDetailRouteImport.update({
    id: '/$category/detail',
    path: '/$category/detail',
    getParentRoute: () => AppDashboardResultsExpenseRoute,
  } as any)
const AppDashboardResultsCostCategoryDetailRoute =
  AppDashboardResultsCostCategoryDetailRouteImport.update({
    id: '/$category/detail',
    path: '/$category/detail',
    getParentRoute: () => AppDashboardResultsCostRoute,
  } as any)
const AppDashboardBalanceLongTermLiabilitiesCategoryDetailRoute =
  AppDashboardBalanceLongTermLiabilitiesCategoryDetailRouteImport.update({
    id: '/$category/detail',
    path: '/$category/detail',
    getParentRoute: () => AppDashboardBalanceLongTermLiabilitiesRoute,
  } as any)
const AppDashboardBalanceLongTermAssetsCategoryDetailRoute =
  AppDashboardBalanceLongTermAssetsCategoryDetailRouteImport.update({
    id: '/$category/detail',
    path: '/$category/detail',
    getParentRoute: () => AppDashboardBalanceLongTermAssetsRoute,
  } as any)
const AppDashboardBalanceCurrentLiabilitiesCategoryDetailRoute =
  AppDashboardBalanceCurrentLiabilitiesCategoryDetailRouteImport.update({
    id: '/$category/detail',
    path: '/$category/detail',
    getParentRoute: () => AppDashboardBalanceCurrentLiabilitiesRoute,
  } as any)
const AppDashboardBalanceCurrentAssetsCategoryDetailRoute =
  AppDashboardBalanceCurrentAssetsCategoryDetailRouteImport.update({
    id: '/$category/detail',
    path: '/$category/detail',
    getParentRoute: () => AppDashboardBalanceCurrentAssetsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/spotlight': typeof SpotlightRoute
  '/livesheet': typeof AppLivesheetRouteWithChildren
  '/auth/verify': typeof AuthVerifyRoute
  '/account/create': typeof AppAccountCreateRoute
  '/ask/mara': typeof AppAskMaraRoute
  '/dashboard/balance': typeof AppDashboardBalanceRouteWithChildren
  '/dashboard/flow': typeof AppDashboardFlowRouteWithChildren
  '/dashboard/metrics': typeof AppDashboardMetricsRouteWithChildren
  '/dashboard/results': typeof AppDashboardResultsRouteWithChildren
  '/dashboard/spotlight-board': typeof AppDashboardSpotlightBoardRoute
  '/dashboard/valuation': typeof AppDashboardValuationRoute
  '/data/integration': typeof AppDataIntegrationRoute
  '/livesheet/balance': typeof AppLivesheetBalanceRoute
  '/livesheet/flujo': typeof AppLivesheetFlujoRoute
  '/livesheet/indicadores': typeof AppLivesheetIndicadoresRoute
  '/livesheet/metricas': typeof AppLivesheetMetricasRoute
  '/livesheet/resultados': typeof AppLivesheetResultadosRoute
  '/livesheet/': typeof AppLivesheetIndexRoute
  '/dashboard/balance/current-assets': typeof AppDashboardBalanceCurrentAssetsRouteWithChildren
  '/dashboard/balance/current-liabilities': typeof AppDashboardBalanceCurrentLiabilitiesRouteWithChildren
  '/dashboard/balance/highlights': typeof AppDashboardBalanceHighlightsRoute
  '/dashboard/balance/long-term-assets': typeof AppDashboardBalanceLongTermAssetsRouteWithChildren
  '/dashboard/balance/long-term-liabilities': typeof AppDashboardBalanceLongTermLiabilitiesRouteWithChildren
  '/dashboard/flow/financing': typeof AppDashboardFlowFinancingRoute
  '/dashboard/flow/highlights': typeof AppDashboardFlowHighlightsRoute
  '/dashboard/flow/investment': typeof AppDashboardFlowInvestmentRoute
  '/dashboard/flow/operation': typeof AppDashboardFlowOperationRoute
  '/dashboard/metrics/efficiency': typeof AppDashboardMetricsEfficiencyRoute
  '/dashboard/metrics/growth': typeof AppDashboardMetricsGrowthRoute
  '/dashboard/metrics/highlights': typeof AppDashboardMetricsHighlightsRoute
  '/dashboard/metrics/liquidity': typeof AppDashboardMetricsLiquidityRoute
  '/dashboard/metrics/management': typeof AppDashboardMetricsManagementRoute
  '/dashboard/metrics/margin': typeof AppDashboardMetricsMarginRoute
  '/dashboard/metrics/return': typeof AppDashboardMetricsReturnRoute
  '/dashboard/metrics/solvency': typeof AppDashboardMetricsSolvencyRoute
  '/dashboard/metrics/stability': typeof AppDashboardMetricsStabilityRoute
  '/dashboard/results/cost': typeof AppDashboardResultsCostRouteWithChildren
  '/dashboard/results/expense': typeof AppDashboardResultsExpenseRouteWithChildren
  '/dashboard/results/highlights': typeof AppDashboardResultsHighlightsRoute
  '/dashboard/results/income': typeof AppDashboardResultsIncomeRouteWithChildren
  '/dashboard/results/other-accounts': typeof AppDashboardResultsOtherAccountsRouteWithChildren
  '/dashboard/balance/current-assets/': typeof AppDashboardBalanceCurrentAssetsIndexRoute
  '/dashboard/balance/current-liabilities/': typeof AppDashboardBalanceCurrentLiabilitiesIndexRoute
  '/dashboard/balance/long-term-assets/': typeof AppDashboardBalanceLongTermAssetsIndexRoute
  '/dashboard/balance/long-term-liabilities/': typeof AppDashboardBalanceLongTermLiabilitiesIndexRoute
  '/dashboard/results/cost/': typeof AppDashboardResultsCostIndexRoute
  '/dashboard/results/expense/': typeof AppDashboardResultsExpenseIndexRoute
  '/dashboard/results/income/': typeof AppDashboardResultsIncomeIndexRoute
  '/dashboard/results/other-accounts/': typeof AppDashboardResultsOtherAccountsIndexRoute
  '/dashboard/balance/current-assets/$category/detail': typeof AppDashboardBalanceCurrentAssetsCategoryDetailRoute
  '/dashboard/balance/current-liabilities/$category/detail': typeof AppDashboardBalanceCurrentLiabilitiesCategoryDetailRoute
  '/dashboard/balance/long-term-assets/$category/detail': typeof AppDashboardBalanceLongTermAssetsCategoryDetailRoute
  '/dashboard/balance/long-term-liabilities/$category/detail': typeof AppDashboardBalanceLongTermLiabilitiesCategoryDetailRoute
  '/dashboard/results/cost/$category/detail': typeof AppDashboardResultsCostCategoryDetailRoute
  '/dashboard/results/expense/$category/detail': typeof AppDashboardResultsExpenseCategoryDetailRoute
  '/dashboard/results/income/$category/detail': typeof AppDashboardResultsIncomeCategoryDetailRoute
  '/dashboard/results/other-accounts/$category/detail': typeof AppDashboardResultsOtherAccountsCategoryDetailRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/spotlight': typeof SpotlightRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/': typeof AppIndexRoute
  '/account/create': typeof AppAccountCreateRoute
  '/ask/mara': typeof AppAskMaraRoute
  '/dashboard/balance': typeof AppDashboardBalanceRouteWithChildren
  '/dashboard/flow': typeof AppDashboardFlowRouteWithChildren
  '/dashboard/metrics': typeof AppDashboardMetricsRouteWithChildren
  '/dashboard/results': typeof AppDashboardResultsRouteWithChildren
  '/dashboard/spotlight-board': typeof AppDashboardSpotlightBoardRoute
  '/dashboard/valuation': typeof AppDashboardValuationRoute
  '/data/integration': typeof AppDataIntegrationRoute
  '/livesheet/balance': typeof AppLivesheetBalanceRoute
  '/livesheet/flujo': typeof AppLivesheetFlujoRoute
  '/livesheet/indicadores': typeof AppLivesheetIndicadoresRoute
  '/livesheet/metricas': typeof AppLivesheetMetricasRoute
  '/livesheet/resultados': typeof AppLivesheetResultadosRoute
  '/livesheet': typeof AppLivesheetIndexRoute
  '/dashboard/balance/highlights': typeof AppDashboardBalanceHighlightsRoute
  '/dashboard/flow/financing': typeof AppDashboardFlowFinancingRoute
  '/dashboard/flow/highlights': typeof AppDashboardFlowHighlightsRoute
  '/dashboard/flow/investment': typeof AppDashboardFlowInvestmentRoute
  '/dashboard/flow/operation': typeof AppDashboardFlowOperationRoute
  '/dashboard/metrics/efficiency': typeof AppDashboardMetricsEfficiencyRoute
  '/dashboard/metrics/growth': typeof AppDashboardMetricsGrowthRoute
  '/dashboard/metrics/highlights': typeof AppDashboardMetricsHighlightsRoute
  '/dashboard/metrics/liquidity': typeof AppDashboardMetricsLiquidityRoute
  '/dashboard/metrics/management': typeof AppDashboardMetricsManagementRoute
  '/dashboard/metrics/margin': typeof AppDashboardMetricsMarginRoute
  '/dashboard/metrics/return': typeof AppDashboardMetricsReturnRoute
  '/dashboard/metrics/solvency': typeof AppDashboardMetricsSolvencyRoute
  '/dashboard/metrics/stability': typeof AppDashboardMetricsStabilityRoute
  '/dashboard/results/highlights': typeof AppDashboardResultsHighlightsRoute
  '/dashboard/balance/current-assets': typeof AppDashboardBalanceCurrentAssetsIndexRoute
  '/dashboard/balance/current-liabilities': typeof AppDashboardBalanceCurrentLiabilitiesIndexRoute
  '/dashboard/balance/long-term-assets': typeof AppDashboardBalanceLongTermAssetsIndexRoute
  '/dashboard/balance/long-term-liabilities': typeof AppDashboardBalanceLongTermLiabilitiesIndexRoute
  '/dashboard/results/cost': typeof AppDashboardResultsCostIndexRoute
  '/dashboard/results/expense': typeof AppDashboardResultsExpenseIndexRoute
  '/dashboard/results/income': typeof AppDashboardResultsIncomeIndexRoute
  '/dashboard/results/other-accounts': typeof AppDashboardResultsOtherAccountsIndexRoute
  '/dashboard/balance/current-assets/$category/detail': typeof AppDashboardBalanceCurrentAssetsCategoryDetailRoute
  '/dashboard/balance/current-liabilities/$category/detail': typeof AppDashboardBalanceCurrentLiabilitiesCategoryDetailRoute
  '/dashboard/balance/long-term-assets/$category/detail': typeof AppDashboardBalanceLongTermAssetsCategoryDetailRoute
  '/dashboard/balance/long-term-liabilities/$category/detail': typeof AppDashboardBalanceLongTermLiabilitiesCategoryDetailRoute
  '/dashboard/results/cost/$category/detail': typeof AppDashboardResultsCostCategoryDetailRoute
  '/dashboard/results/expense/$category/detail': typeof AppDashboardResultsExpenseCategoryDetailRoute
  '/dashboard/results/income/$category/detail': typeof AppDashboardResultsIncomeCategoryDetailRoute
  '/dashboard/results/other-accounts/$category/detail': typeof AppDashboardResultsOtherAccountsCategoryDetailRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/spotlight': typeof SpotlightRoute
  '/_app/livesheet': typeof AppLivesheetRouteWithChildren
  '/auth/verify': typeof AuthVerifyRoute
  '/_app/': typeof AppIndexRoute
  '/_app/account/create': typeof AppAccountCreateRoute
  '/_app/ask/mara': typeof AppAskMaraRoute
  '/_app/dashboard/balance': typeof AppDashboardBalanceRouteWithChildren
  '/_app/dashboard/flow': typeof AppDashboardFlowRouteWithChildren
  '/_app/dashboard/metrics': typeof AppDashboardMetricsRouteWithChildren
  '/_app/dashboard/results': typeof AppDashboardResultsRouteWithChildren
  '/_app/dashboard/spotlight-board': typeof AppDashboardSpotlightBoardRoute
  '/_app/dashboard/valuation': typeof AppDashboardValuationRoute
  '/_app/data/integration': typeof AppDataIntegrationRoute
  '/_app/livesheet/balance': typeof AppLivesheetBalanceRoute
  '/_app/livesheet/flujo': typeof AppLivesheetFlujoRoute
  '/_app/livesheet/indicadores': typeof AppLivesheetIndicadoresRoute
  '/_app/livesheet/metricas': typeof AppLivesheetMetricasRoute
  '/_app/livesheet/resultados': typeof AppLivesheetResultadosRoute
  '/_app/livesheet/': typeof AppLivesheetIndexRoute
  '/_app/dashboard/balance/current-assets': typeof AppDashboardBalanceCurrentAssetsRouteWithChildren
  '/_app/dashboard/balance/current-liabilities': typeof AppDashboardBalanceCurrentLiabilitiesRouteWithChildren
  '/_app/dashboard/balance/highlights': typeof AppDashboardBalanceHighlightsRoute
  '/_app/dashboard/balance/long-term-assets': typeof AppDashboardBalanceLongTermAssetsRouteWithChildren
  '/_app/dashboard/balance/long-term-liabilities': typeof AppDashboardBalanceLongTermLiabilitiesRouteWithChildren
  '/_app/dashboard/flow/financing': typeof AppDashboardFlowFinancingRoute
  '/_app/dashboard/flow/highlights': typeof AppDashboardFlowHighlightsRoute
  '/_app/dashboard/flow/investment': typeof AppDashboardFlowInvestmentRoute
  '/_app/dashboard/flow/operation': typeof AppDashboardFlowOperationRoute
  '/_app/dashboard/metrics/efficiency': typeof AppDashboardMetricsEfficiencyRoute
  '/_app/dashboard/metrics/growth': typeof AppDashboardMetricsGrowthRoute
  '/_app/dashboard/metrics/highlights': typeof AppDashboardMetricsHighlightsRoute
  '/_app/dashboard/metrics/liquidity': typeof AppDashboardMetricsLiquidityRoute
  '/_app/dashboard/metrics/management': typeof AppDashboardMetricsManagementRoute
  '/_app/dashboard/metrics/margin': typeof AppDashboardMetricsMarginRoute
  '/_app/dashboard/metrics/return': typeof AppDashboardMetricsReturnRoute
  '/_app/dashboard/metrics/solvency': typeof AppDashboardMetricsSolvencyRoute
  '/_app/dashboard/metrics/stability': typeof AppDashboardMetricsStabilityRoute
  '/_app/dashboard/results/cost': typeof AppDashboardResultsCostRouteWithChildren
  '/_app/dashboard/results/expense': typeof AppDashboardResultsExpenseRouteWithChildren
  '/_app/dashboard/results/highlights': typeof AppDashboardResultsHighlightsRoute
  '/_app/dashboard/results/income': typeof AppDashboardResultsIncomeRouteWithChildren
  '/_app/dashboard/results/other-accounts': typeof AppDashboardResultsOtherAccountsRouteWithChildren
  '/_app/dashboard/balance/current-assets/': typeof AppDashboardBalanceCurrentAssetsIndexRoute
  '/_app/dashboard/balance/current-liabilities/': typeof AppDashboardBalanceCurrentLiabilitiesIndexRoute
  '/_app/dashboard/balance/long-term-assets/': typeof AppDashboardBalanceLongTermAssetsIndexRoute
  '/_app/dashboard/balance/long-term-liabilities/': typeof AppDashboardBalanceLongTermLiabilitiesIndexRoute
  '/_app/dashboard/results/cost/': typeof AppDashboardResultsCostIndexRoute
  '/_app/dashboard/results/expense/': typeof AppDashboardResultsExpenseIndexRoute
  '/_app/dashboard/results/income/': typeof AppDashboardResultsIncomeIndexRoute
  '/_app/dashboard/results/other-accounts/': typeof AppDashboardResultsOtherAccountsIndexRoute
  '/_app/dashboard/balance/current-assets/$category/detail': typeof AppDashboardBalanceCurrentAssetsCategoryDetailRoute
  '/_app/dashboard/balance/current-liabilities/$category/detail': typeof AppDashboardBalanceCurrentLiabilitiesCategoryDetailRoute
  '/_app/dashboard/balance/long-term-assets/$category/detail': typeof AppDashboardBalanceLongTermAssetsCategoryDetailRoute
  '/_app/dashboard/balance/long-term-liabilities/$category/detail': typeof AppDashboardBalanceLongTermLiabilitiesCategoryDetailRoute
  '/_app/dashboard/results/cost/$category/detail': typeof AppDashboardResultsCostCategoryDetailRoute
  '/_app/dashboard/results/expense/$category/detail': typeof AppDashboardResultsExpenseCategoryDetailRoute
  '/_app/dashboard/results/income/$category/detail': typeof AppDashboardResultsIncomeCategoryDetailRoute
  '/_app/dashboard/results/other-accounts/$category/detail': typeof AppDashboardResultsOtherAccountsCategoryDetailRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/spotlight'
    | '/livesheet'
    | '/auth/verify'
    | '/account/create'
    | '/ask/mara'
    | '/dashboard/balance'
    | '/dashboard/flow'
    | '/dashboard/metrics'
    | '/dashboard/results'
    | '/dashboard/spotlight-board'
    | '/dashboard/valuation'
    | '/data/integration'
    | '/livesheet/balance'
    | '/livesheet/flujo'
    | '/livesheet/indicadores'
    | '/livesheet/metricas'
    | '/livesheet/resultados'
    | '/livesheet/'
    | '/dashboard/balance/current-assets'
    | '/dashboard/balance/current-liabilities'
    | '/dashboard/balance/highlights'
    | '/dashboard/balance/long-term-assets'
    | '/dashboard/balance/long-term-liabilities'
    | '/dashboard/flow/financing'
    | '/dashboard/flow/highlights'
    | '/dashboard/flow/investment'
    | '/dashboard/flow/operation'
    | '/dashboard/metrics/efficiency'
    | '/dashboard/metrics/growth'
    | '/dashboard/metrics/highlights'
    | '/dashboard/metrics/liquidity'
    | '/dashboard/metrics/management'
    | '/dashboard/metrics/margin'
    | '/dashboard/metrics/return'
    | '/dashboard/metrics/solvency'
    | '/dashboard/metrics/stability'
    | '/dashboard/results/cost'
    | '/dashboard/results/expense'
    | '/dashboard/results/highlights'
    | '/dashboard/results/income'
    | '/dashboard/results/other-accounts'
    | '/dashboard/balance/current-assets/'
    | '/dashboard/balance/current-liabilities/'
    | '/dashboard/balance/long-term-assets/'
    | '/dashboard/balance/long-term-liabilities/'
    | '/dashboard/results/cost/'
    | '/dashboard/results/expense/'
    | '/dashboard/results/income/'
    | '/dashboard/results/other-accounts/'
    | '/dashboard/balance/current-assets/$category/detail'
    | '/dashboard/balance/current-liabilities/$category/detail'
    | '/dashboard/balance/long-term-assets/$category/detail'
    | '/dashboard/balance/long-term-liabilities/$category/detail'
    | '/dashboard/results/cost/$category/detail'
    | '/dashboard/results/expense/$category/detail'
    | '/dashboard/results/income/$category/detail'
    | '/dashboard/results/other-accounts/$category/detail'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/signup'
    | '/spotlight'
    | '/auth/verify'
    | '/'
    | '/account/create'
    | '/ask/mara'
    | '/dashboard/balance'
    | '/dashboard/flow'
    | '/dashboard/metrics'
    | '/dashboard/results'
    | '/dashboard/spotlight-board'
    | '/dashboard/valuation'
    | '/data/integration'
    | '/livesheet/balance'
    | '/livesheet/flujo'
    | '/livesheet/indicadores'
    | '/livesheet/metricas'
    | '/livesheet/resultados'
    | '/livesheet'
    | '/dashboard/balance/highlights'
    | '/dashboard/flow/financing'
    | '/dashboard/flow/highlights'
    | '/dashboard/flow/investment'
    | '/dashboard/flow/operation'
    | '/dashboard/metrics/efficiency'
    | '/dashboard/metrics/growth'
    | '/dashboard/metrics/highlights'
    | '/dashboard/metrics/liquidity'
    | '/dashboard/metrics/management'
    | '/dashboard/metrics/margin'
    | '/dashboard/metrics/return'
    | '/dashboard/metrics/solvency'
    | '/dashboard/metrics/stability'
    | '/dashboard/results/highlights'
    | '/dashboard/balance/current-assets'
    | '/dashboard/balance/current-liabilities'
    | '/dashboard/balance/long-term-assets'
    | '/dashboard/balance/long-term-liabilities'
    | '/dashboard/results/cost'
    | '/dashboard/results/expense'
    | '/dashboard/results/income'
    | '/dashboard/results/other-accounts'
    | '/dashboard/balance/current-assets/$category/detail'
    | '/dashboard/balance/current-liabilities/$category/detail'
    | '/dashboard/balance/long-term-assets/$category/detail'
    | '/dashboard/balance/long-term-liabilities/$category/detail'
    | '/dashboard/results/cost/$category/detail'
    | '/dashboard/results/expense/$category/detail'
    | '/dashboard/results/income/$category/detail'
    | '/dashboard/results/other-accounts/$category/detail'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/signup'
    | '/spotlight'
    | '/_app/livesheet'
    | '/auth/verify'
    | '/_app/'
    | '/_app/account/create'
    | '/_app/ask/mara'
    | '/_app/dashboard/balance'
    | '/_app/dashboard/flow'
    | '/_app/dashboard/metrics'
    | '/_app/dashboard/results'
    | '/_app/dashboard/spotlight-board'
    | '/_app/dashboard/valuation'
    | '/_app/data/integration'
    | '/_app/livesheet/balance'
    | '/_app/livesheet/flujo'
    | '/_app/livesheet/indicadores'
    | '/_app/livesheet/metricas'
    | '/_app/livesheet/resultados'
    | '/_app/livesheet/'
    | '/_app/dashboard/balance/current-assets'
    | '/_app/dashboard/balance/current-liabilities'
    | '/_app/dashboard/balance/highlights'
    | '/_app/dashboard/balance/long-term-assets'
    | '/_app/dashboard/balance/long-term-liabilities'
    | '/_app/dashboard/flow/financing'
    | '/_app/dashboard/flow/highlights'
    | '/_app/dashboard/flow/investment'
    | '/_app/dashboard/flow/operation'
    | '/_app/dashboard/metrics/efficiency'
    | '/_app/dashboard/metrics/growth'
    | '/_app/dashboard/metrics/highlights'
    | '/_app/dashboard/metrics/liquidity'
    | '/_app/dashboard/metrics/management'
    | '/_app/dashboard/metrics/margin'
    | '/_app/dashboard/metrics/return'
    | '/_app/dashboard/metrics/solvency'
    | '/_app/dashboard/metrics/stability'
    | '/_app/dashboard/results/cost'
    | '/_app/dashboard/results/expense'
    | '/_app/dashboard/results/highlights'
    | '/_app/dashboard/results/income'
    | '/_app/dashboard/results/other-accounts'
    | '/_app/dashboard/balance/current-assets/'
    | '/_app/dashboard/balance/current-liabilities/'
    | '/_app/dashboard/balance/long-term-assets/'
    | '/_app/dashboard/balance/long-term-liabilities/'
    | '/_app/dashboard/results/cost/'
    | '/_app/dashboard/results/expense/'
    | '/_app/dashboard/results/income/'
    | '/_app/dashboard/results/other-accounts/'
    | '/_app/dashboard/balance/current-assets/$category/detail'
    | '/_app/dashboard/balance/current-liabilities/$category/detail'
    | '/_app/dashboard/balance/long-term-assets/$category/detail'
    | '/_app/dashboard/balance/long-term-liabilities/$category/detail'
    | '/_app/dashboard/results/cost/$category/detail'
    | '/_app/dashboard/results/expense/$category/detail'
    | '/_app/dashboard/results/income/$category/detail'
    | '/_app/dashboard/results/other-accounts/$category/detail'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  SpotlightRoute: typeof SpotlightRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/spotlight': {
      id: '/spotlight'
      path: '/spotlight'
      fullPath: '/spotlight'
      preLoaderRoute: typeof SpotlightRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/livesheet': {
      id: '/_app/livesheet'
      path: '/livesheet'
      fullPath: '/livesheet'
      preLoaderRoute: typeof AppLivesheetRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/livesheet/': {
      id: '/_app/livesheet/'
      path: '/'
      fullPath: '/livesheet/'
      preLoaderRoute: typeof AppLivesheetIndexRouteImport
      parentRoute: typeof AppLivesheetRoute
    }
    '/_app/livesheet/resultados': {
      id: '/_app/livesheet/resultados'
      path: '/resultados'
      fullPath: '/livesheet/resultados'
      preLoaderRoute: typeof AppLivesheetResultadosRouteImport
      parentRoute: typeof AppLivesheetRoute
    }
    '/_app/livesheet/metricas': {
      id: '/_app/livesheet/metricas'
      path: '/metricas'
      fullPath: '/livesheet/metricas'
      preLoaderRoute: typeof AppLivesheetMetricasRouteImport
      parentRoute: typeof AppLivesheetRoute
    }
    '/_app/livesheet/indicadores': {
      id: '/_app/livesheet/indicadores'
      path: '/indicadores'
      fullPath: '/livesheet/indicadores'
      preLoaderRoute: typeof AppLivesheetIndicadoresRouteImport
      parentRoute: typeof AppLivesheetRoute
    }
    '/_app/livesheet/flujo': {
      id: '/_app/livesheet/flujo'
      path: '/flujo'
      fullPath: '/livesheet/flujo'
      preLoaderRoute: typeof AppLivesheetFlujoRouteImport
      parentRoute: typeof AppLivesheetRoute
    }
    '/_app/livesheet/balance': {
      id: '/_app/livesheet/balance'
      path: '/balance'
      fullPath: '/livesheet/balance'
      preLoaderRoute: typeof AppLivesheetBalanceRouteImport
      parentRoute: typeof AppLivesheetRoute
    }
    '/_app/data/integration': {
      id: '/_app/data/integration'
      path: '/data/integration'
      fullPath: '/data/integration'
      preLoaderRoute: typeof AppDataIntegrationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/valuation': {
      id: '/_app/dashboard/valuation'
      path: '/dashboard/valuation'
      fullPath: '/dashboard/valuation'
      preLoaderRoute: typeof AppDashboardValuationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/spotlight-board': {
      id: '/_app/dashboard/spotlight-board'
      path: '/dashboard/spotlight-board'
      fullPath: '/dashboard/spotlight-board'
      preLoaderRoute: typeof AppDashboardSpotlightBoardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/results': {
      id: '/_app/dashboard/results'
      path: '/dashboard/results'
      fullPath: '/dashboard/results'
      preLoaderRoute: typeof AppDashboardResultsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/metrics': {
      id: '/_app/dashboard/metrics'
      path: '/dashboard/metrics'
      fullPath: '/dashboard/metrics'
      preLoaderRoute: typeof AppDashboardMetricsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/flow': {
      id: '/_app/dashboard/flow'
      path: '/dashboard/flow'
      fullPath: '/dashboard/flow'
      preLoaderRoute: typeof AppDashboardFlowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/balance': {
      id: '/_app/dashboard/balance'
      path: '/dashboard/balance'
      fullPath: '/dashboard/balance'
      preLoaderRoute: typeof AppDashboardBalanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ask/mara': {
      id: '/_app/ask/mara'
      path: '/ask/mara'
      fullPath: '/ask/mara'
      preLoaderRoute: typeof AppAskMaraRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account/create': {
      id: '/_app/account/create'
      path: '/account/create'
      fullPath: '/account/create'
      preLoaderRoute: typeof AppAccountCreateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/results/other-accounts': {
      id: '/_app/dashboard/results/other-accounts'
      path: '/other-accounts'
      fullPath: '/dashboard/results/other-accounts'
      preLoaderRoute: typeof AppDashboardResultsOtherAccountsRouteImport
      parentRoute: typeof AppDashboardResultsRoute
    }
    '/_app/dashboard/results/income': {
      id: '/_app/dashboard/results/income'
      path: '/income'
      fullPath: '/dashboard/results/income'
      preLoaderRoute: typeof AppDashboardResultsIncomeRouteImport
      parentRoute: typeof AppDashboardResultsRoute
    }
    '/_app/dashboard/results/highlights': {
      id: '/_app/dashboard/results/highlights'
      path: '/highlights'
      fullPath: '/dashboard/results/highlights'
      preLoaderRoute: typeof AppDashboardResultsHighlightsRouteImport
      parentRoute: typeof AppDashboardResultsRoute
    }
    '/_app/dashboard/results/expense': {
      id: '/_app/dashboard/results/expense'
      path: '/expense'
      fullPath: '/dashboard/results/expense'
      preLoaderRoute: typeof AppDashboardResultsExpenseRouteImport
      parentRoute: typeof AppDashboardResultsRoute
    }
    '/_app/dashboard/results/cost': {
      id: '/_app/dashboard/results/cost'
      path: '/cost'
      fullPath: '/dashboard/results/cost'
      preLoaderRoute: typeof AppDashboardResultsCostRouteImport
      parentRoute: typeof AppDashboardResultsRoute
    }
    '/_app/dashboard/metrics/stability': {
      id: '/_app/dashboard/metrics/stability'
      path: '/stability'
      fullPath: '/dashboard/metrics/stability'
      preLoaderRoute: typeof AppDashboardMetricsStabilityRouteImport
      parentRoute: typeof AppDashboardMetricsRoute
    }
    '/_app/dashboard/metrics/solvency': {
      id: '/_app/dashboard/metrics/solvency'
      path: '/solvency'
      fullPath: '/dashboard/metrics/solvency'
      preLoaderRoute: typeof AppDashboardMetricsSolvencyRouteImport
      parentRoute: typeof AppDashboardMetricsRoute
    }
    '/_app/dashboard/metrics/return': {
      id: '/_app/dashboard/metrics/return'
      path: '/return'
      fullPath: '/dashboard/metrics/return'
      preLoaderRoute: typeof AppDashboardMetricsReturnRouteImport
      parentRoute: typeof AppDashboardMetricsRoute
    }
    '/_app/dashboard/metrics/margin': {
      id: '/_app/dashboard/metrics/margin'
      path: '/margin'
      fullPath: '/dashboard/metrics/margin'
      preLoaderRoute: typeof AppDashboardMetricsMarginRouteImport
      parentRoute: typeof AppDashboardMetricsRoute
    }
    '/_app/dashboard/metrics/management': {
      id: '/_app/dashboard/metrics/management'
      path: '/management'
      fullPath: '/dashboard/metrics/management'
      preLoaderRoute: typeof AppDashboardMetricsManagementRouteImport
      parentRoute: typeof AppDashboardMetricsRoute
    }
    '/_app/dashboard/metrics/liquidity': {
      id: '/_app/dashboard/metrics/liquidity'
      path: '/liquidity'
      fullPath: '/dashboard/metrics/liquidity'
      preLoaderRoute: typeof AppDashboardMetricsLiquidityRouteImport
      parentRoute: typeof AppDashboardMetricsRoute
    }
    '/_app/dashboard/metrics/highlights': {
      id: '/_app/dashboard/metrics/highlights'
      path: '/highlights'
      fullPath: '/dashboard/metrics/highlights'
      preLoaderRoute: typeof AppDashboardMetricsHighlightsRouteImport
      parentRoute: typeof AppDashboardMetricsRoute
    }
    '/_app/dashboard/metrics/growth': {
      id: '/_app/dashboard/metrics/growth'
      path: '/growth'
      fullPath: '/dashboard/metrics/growth'
      preLoaderRoute: typeof AppDashboardMetricsGrowthRouteImport
      parentRoute: typeof AppDashboardMetricsRoute
    }
    '/_app/dashboard/metrics/efficiency': {
      id: '/_app/dashboard/metrics/efficiency'
      path: '/efficiency'
      fullPath: '/dashboard/metrics/efficiency'
      preLoaderRoute: typeof AppDashboardMetricsEfficiencyRouteImport
      parentRoute: typeof AppDashboardMetricsRoute
    }
    '/_app/dashboard/flow/operation': {
      id: '/_app/dashboard/flow/operation'
      path: '/operation'
      fullPath: '/dashboard/flow/operation'
      preLoaderRoute: typeof AppDashboardFlowOperationRouteImport
      parentRoute: typeof AppDashboardFlowRoute
    }
    '/_app/dashboard/flow/investment': {
      id: '/_app/dashboard/flow/investment'
      path: '/investment'
      fullPath: '/dashboard/flow/investment'
      preLoaderRoute: typeof AppDashboardFlowInvestmentRouteImport
      parentRoute: typeof AppDashboardFlowRoute
    }
    '/_app/dashboard/flow/highlights': {
      id: '/_app/dashboard/flow/highlights'
      path: '/highlights'
      fullPath: '/dashboard/flow/highlights'
      preLoaderRoute: typeof AppDashboardFlowHighlightsRouteImport
      parentRoute: typeof AppDashboardFlowRoute
    }
    '/_app/dashboard/flow/financing': {
      id: '/_app/dashboard/flow/financing'
      path: '/financing'
      fullPath: '/dashboard/flow/financing'
      preLoaderRoute: typeof AppDashboardFlowFinancingRouteImport
      parentRoute: typeof AppDashboardFlowRoute
    }
    '/_app/dashboard/balance/long-term-liabilities': {
      id: '/_app/dashboard/balance/long-term-liabilities'
      path: '/long-term-liabilities'
      fullPath: '/dashboard/balance/long-term-liabilities'
      preLoaderRoute: typeof AppDashboardBalanceLongTermLiabilitiesRouteImport
      parentRoute: typeof AppDashboardBalanceRoute
    }
    '/_app/dashboard/balance/long-term-assets': {
      id: '/_app/dashboard/balance/long-term-assets'
      path: '/long-term-assets'
      fullPath: '/dashboard/balance/long-term-assets'
      preLoaderRoute: typeof AppDashboardBalanceLongTermAssetsRouteImport
      parentRoute: typeof AppDashboardBalanceRoute
    }
    '/_app/dashboard/balance/highlights': {
      id: '/_app/dashboard/balance/highlights'
      path: '/highlights'
      fullPath: '/dashboard/balance/highlights'
      preLoaderRoute: typeof AppDashboardBalanceHighlightsRouteImport
      parentRoute: typeof AppDashboardBalanceRoute
    }
    '/_app/dashboard/balance/current-liabilities': {
      id: '/_app/dashboard/balance/current-liabilities'
      path: '/current-liabilities'
      fullPath: '/dashboard/balance/current-liabilities'
      preLoaderRoute: typeof AppDashboardBalanceCurrentLiabilitiesRouteImport
      parentRoute: typeof AppDashboardBalanceRoute
    }
    '/_app/dashboard/balance/current-assets': {
      id: '/_app/dashboard/balance/current-assets'
      path: '/current-assets'
      fullPath: '/dashboard/balance/current-assets'
      preLoaderRoute: typeof AppDashboardBalanceCurrentAssetsRouteImport
      parentRoute: typeof AppDashboardBalanceRoute
    }
    '/_app/dashboard/results/other-accounts/': {
      id: '/_app/dashboard/results/other-accounts/'
      path: '/'
      fullPath: '/dashboard/results/other-accounts/'
      preLoaderRoute: typeof AppDashboardResultsOtherAccountsIndexRouteImport
      parentRoute: typeof AppDashboardResultsOtherAccountsRoute
    }
    '/_app/dashboard/results/income/': {
      id: '/_app/dashboard/results/income/'
      path: '/'
      fullPath: '/dashboard/results/income/'
      preLoaderRoute: typeof AppDashboardResultsIncomeIndexRouteImport
      parentRoute: typeof AppDashboardResultsIncomeRoute
    }
    '/_app/dashboard/results/expense/': {
      id: '/_app/dashboard/results/expense/'
      path: '/'
      fullPath: '/dashboard/results/expense/'
      preLoaderRoute: typeof AppDashboardResultsExpenseIndexRouteImport
      parentRoute: typeof AppDashboardResultsExpenseRoute
    }
    '/_app/dashboard/results/cost/': {
      id: '/_app/dashboard/results/cost/'
      path: '/'
      fullPath: '/dashboard/results/cost/'
      preLoaderRoute: typeof AppDashboardResultsCostIndexRouteImport
      parentRoute: typeof AppDashboardResultsCostRoute
    }
    '/_app/dashboard/balance/long-term-liabilities/': {
      id: '/_app/dashboard/balance/long-term-liabilities/'
      path: '/'
      fullPath: '/dashboard/balance/long-term-liabilities/'
      preLoaderRoute: typeof AppDashboardBalanceLongTermLiabilitiesIndexRouteImport
      parentRoute: typeof AppDashboardBalanceLongTermLiabilitiesRoute
    }
    '/_app/dashboard/balance/long-term-assets/': {
      id: '/_app/dashboard/balance/long-term-assets/'
      path: '/'
      fullPath: '/dashboard/balance/long-term-assets/'
      preLoaderRoute: typeof AppDashboardBalanceLongTermAssetsIndexRouteImport
      parentRoute: typeof AppDashboardBalanceLongTermAssetsRoute
    }
    '/_app/dashboard/balance/current-liabilities/': {
      id: '/_app/dashboard/balance/current-liabilities/'
      path: '/'
      fullPath: '/dashboard/balance/current-liabilities/'
      preLoaderRoute: typeof AppDashboardBalanceCurrentLiabilitiesIndexRouteImport
      parentRoute: typeof AppDashboardBalanceCurrentLiabilitiesRoute
    }
    '/_app/dashboard/balance/current-assets/': {
      id: '/_app/dashboard/balance/current-assets/'
      path: '/'
      fullPath: '/dashboard/balance/current-assets/'
      preLoaderRoute: typeof AppDashboardBalanceCurrentAssetsIndexRouteImport
      parentRoute: typeof AppDashboardBalanceCurrentAssetsRoute
    }
    '/_app/dashboard/results/other-accounts/$category/detail': {
      id: '/_app/dashboard/results/other-accounts/$category/detail'
      path: '/$category/detail'
      fullPath: '/dashboard/results/other-accounts/$category/detail'
      preLoaderRoute: typeof AppDashboardResultsOtherAccountsCategoryDetailRouteImport
      parentRoute: typeof AppDashboardResultsOtherAccountsRoute
    }
    '/_app/dashboard/results/income/$category/detail': {
      id: '/_app/dashboard/results/income/$category/detail'
      path: '/$category/detail'
      fullPath: '/dashboard/results/income/$category/detail'
      preLoaderRoute: typeof AppDashboardResultsIncomeCategoryDetailRouteImport
      parentRoute: typeof AppDashboardResultsIncomeRoute
    }
    '/_app/dashboard/results/expense/$category/detail': {
      id: '/_app/dashboard/results/expense/$category/detail'
      path: '/$category/detail'
      fullPath: '/dashboard/results/expense/$category/detail'
      preLoaderRoute: typeof AppDashboardResultsExpenseCategoryDetailRouteImport
      parentRoute: typeof AppDashboardResultsExpenseRoute
    }
    '/_app/dashboard/results/cost/$category/detail': {
      id: '/_app/dashboard/results/cost/$category/detail'
      path: '/$category/detail'
      fullPath: '/dashboard/results/cost/$category/detail'
      preLoaderRoute: typeof AppDashboardResultsCostCategoryDetailRouteImport
      parentRoute: typeof AppDashboardResultsCostRoute
    }
    '/_app/dashboard/balance/long-term-liabilities/$category/detail': {
      id: '/_app/dashboard/balance/long-term-liabilities/$category/detail'
      path: '/$category/detail'
      fullPath: '/dashboard/balance/long-term-liabilities/$category/detail'
      preLoaderRoute: typeof AppDashboardBalanceLongTermLiabilitiesCategoryDetailRouteImport
      parentRoute: typeof AppDashboardBalanceLongTermLiabilitiesRoute
    }
    '/_app/dashboard/balance/long-term-assets/$category/detail': {
      id: '/_app/dashboard/balance/long-term-assets/$category/detail'
      path: '/$category/detail'
      fullPath: '/dashboard/balance/long-term-assets/$category/detail'
      preLoaderRoute: typeof AppDashboardBalanceLongTermAssetsCategoryDetailRouteImport
      parentRoute: typeof AppDashboardBalanceLongTermAssetsRoute
    }
    '/_app/dashboard/balance/current-liabilities/$category/detail': {
      id: '/_app/dashboard/balance/current-liabilities/$category/detail'
      path: '/$category/detail'
      fullPath: '/dashboard/balance/current-liabilities/$category/detail'
      preLoaderRoute: typeof AppDashboardBalanceCurrentLiabilitiesCategoryDetailRouteImport
      parentRoute: typeof AppDashboardBalanceCurrentLiabilitiesRoute
    }
    '/_app/dashboard/balance/current-assets/$category/detail': {
      id: '/_app/dashboard/balance/current-assets/$category/detail'
      path: '/$category/detail'
      fullPath: '/dashboard/balance/current-assets/$category/detail'
      preLoaderRoute: typeof AppDashboardBalanceCurrentAssetsCategoryDetailRouteImport
      parentRoute: typeof AppDashboardBalanceCurrentAssetsRoute
    }
  }
}

interface AppLivesheetRouteChildren {
  AppLivesheetBalanceRoute: typeof AppLivesheetBalanceRoute
  AppLivesheetFlujoRoute: typeof AppLivesheetFlujoRoute
  AppLivesheetIndicadoresRoute: typeof AppLivesheetIndicadoresRoute
  AppLivesheetMetricasRoute: typeof AppLivesheetMetricasRoute
  AppLivesheetResultadosRoute: typeof AppLivesheetResultadosRoute
  AppLivesheetIndexRoute: typeof AppLivesheetIndexRoute
}

const AppLivesheetRouteChildren: AppLivesheetRouteChildren = {
  AppLivesheetBalanceRoute: AppLivesheetBalanceRoute,
  AppLivesheetFlujoRoute: AppLivesheetFlujoRoute,
  AppLivesheetIndicadoresRoute: AppLivesheetIndicadoresRoute,
  AppLivesheetMetricasRoute: AppLivesheetMetricasRoute,
  AppLivesheetResultadosRoute: AppLivesheetResultadosRoute,
  AppLivesheetIndexRoute: AppLivesheetIndexRoute,
}

const AppLivesheetRouteWithChildren = AppLivesheetRoute._addFileChildren(
  AppLivesheetRouteChildren,
)

interface AppDashboardBalanceCurrentAssetsRouteChildren {
  AppDashboardBalanceCurrentAssetsIndexRoute: typeof AppDashboardBalanceCurrentAssetsIndexRoute
  AppDashboardBalanceCurrentAssetsCategoryDetailRoute: typeof AppDashboardBalanceCurrentAssetsCategoryDetailRoute
}

const AppDashboardBalanceCurrentAssetsRouteChildren: AppDashboardBalanceCurrentAssetsRouteChildren =
  {
    AppDashboardBalanceCurrentAssetsIndexRoute:
      AppDashboardBalanceCurrentAssetsIndexRoute,
    AppDashboardBalanceCurrentAssetsCategoryDetailRoute:
      AppDashboardBalanceCurrentAssetsCategoryDetailRoute,
  }

const AppDashboardBalanceCurrentAssetsRouteWithChildren =
  AppDashboardBalanceCurrentAssetsRoute._addFileChildren(
    AppDashboardBalanceCurrentAssetsRouteChildren,
  )

interface AppDashboardBalanceCurrentLiabilitiesRouteChildren {
  AppDashboardBalanceCurrentLiabilitiesIndexRoute: typeof AppDashboardBalanceCurrentLiabilitiesIndexRoute
  AppDashboardBalanceCurrentLiabilitiesCategoryDetailRoute: typeof AppDashboardBalanceCurrentLiabilitiesCategoryDetailRoute
}

const AppDashboardBalanceCurrentLiabilitiesRouteChildren: AppDashboardBalanceCurrentLiabilitiesRouteChildren =
  {
    AppDashboardBalanceCurrentLiabilitiesIndexRoute:
      AppDashboardBalanceCurrentLiabilitiesIndexRoute,
    AppDashboardBalanceCurrentLiabilitiesCategoryDetailRoute:
      AppDashboardBalanceCurrentLiabilitiesCategoryDetailRoute,
  }

const AppDashboardBalanceCurrentLiabilitiesRouteWithChildren =
  AppDashboardBalanceCurrentLiabilitiesRoute._addFileChildren(
    AppDashboardBalanceCurrentLiabilitiesRouteChildren,
  )

interface AppDashboardBalanceLongTermAssetsRouteChildren {
  AppDashboardBalanceLongTermAssetsIndexRoute: typeof AppDashboardBalanceLongTermAssetsIndexRoute
  AppDashboardBalanceLongTermAssetsCategoryDetailRoute: typeof AppDashboardBalanceLongTermAssetsCategoryDetailRoute
}

const AppDashboardBalanceLongTermAssetsRouteChildren: AppDashboardBalanceLongTermAssetsRouteChildren =
  {
    AppDashboardBalanceLongTermAssetsIndexRoute:
      AppDashboardBalanceLongTermAssetsIndexRoute,
    AppDashboardBalanceLongTermAssetsCategoryDetailRoute:
      AppDashboardBalanceLongTermAssetsCategoryDetailRoute,
  }

const AppDashboardBalanceLongTermAssetsRouteWithChildren =
  AppDashboardBalanceLongTermAssetsRoute._addFileChildren(
    AppDashboardBalanceLongTermAssetsRouteChildren,
  )

interface AppDashboardBalanceLongTermLiabilitiesRouteChildren {
  AppDashboardBalanceLongTermLiabilitiesIndexRoute: typeof AppDashboardBalanceLongTermLiabilitiesIndexRoute
  AppDashboardBalanceLongTermLiabilitiesCategoryDetailRoute: typeof AppDashboardBalanceLongTermLiabilitiesCategoryDetailRoute
}

const AppDashboardBalanceLongTermLiabilitiesRouteChildren: AppDashboardBalanceLongTermLiabilitiesRouteChildren =
  {
    AppDashboardBalanceLongTermLiabilitiesIndexRoute:
      AppDashboardBalanceLongTermLiabilitiesIndexRoute,
    AppDashboardBalanceLongTermLiabilitiesCategoryDetailRoute:
      AppDashboardBalanceLongTermLiabilitiesCategoryDetailRoute,
  }

const AppDashboardBalanceLongTermLiabilitiesRouteWithChildren =
  AppDashboardBalanceLongTermLiabilitiesRoute._addFileChildren(
    AppDashboardBalanceLongTermLiabilitiesRouteChildren,
  )

interface AppDashboardBalanceRouteChildren {
  AppDashboardBalanceCurrentAssetsRoute: typeof AppDashboardBalanceCurrentAssetsRouteWithChildren
  AppDashboardBalanceCurrentLiabilitiesRoute: typeof AppDashboardBalanceCurrentLiabilitiesRouteWithChildren
  AppDashboardBalanceHighlightsRoute: typeof AppDashboardBalanceHighlightsRoute
  AppDashboardBalanceLongTermAssetsRoute: typeof AppDashboardBalanceLongTermAssetsRouteWithChildren
  AppDashboardBalanceLongTermLiabilitiesRoute: typeof AppDashboardBalanceLongTermLiabilitiesRouteWithChildren
}

const AppDashboardBalanceRouteChildren: AppDashboardBalanceRouteChildren = {
  AppDashboardBalanceCurrentAssetsRoute:
    AppDashboardBalanceCurrentAssetsRouteWithChildren,
  AppDashboardBalanceCurrentLiabilitiesRoute:
    AppDashboardBalanceCurrentLiabilitiesRouteWithChildren,
  AppDashboardBalanceHighlightsRoute: AppDashboardBalanceHighlightsRoute,
  AppDashboardBalanceLongTermAssetsRoute:
    AppDashboardBalanceLongTermAssetsRouteWithChildren,
  AppDashboardBalanceLongTermLiabilitiesRoute:
    AppDashboardBalanceLongTermLiabilitiesRouteWithChildren,
}

const AppDashboardBalanceRouteWithChildren =
  AppDashboardBalanceRoute._addFileChildren(AppDashboardBalanceRouteChildren)

interface AppDashboardFlowRouteChildren {
  AppDashboardFlowFinancingRoute: typeof AppDashboardFlowFinancingRoute
  AppDashboardFlowHighlightsRoute: typeof AppDashboardFlowHighlightsRoute
  AppDashboardFlowInvestmentRoute: typeof AppDashboardFlowInvestmentRoute
  AppDashboardFlowOperationRoute: typeof AppDashboardFlowOperationRoute
}

const AppDashboardFlowRouteChildren: AppDashboardFlowRouteChildren = {
  AppDashboardFlowFinancingRoute: AppDashboardFlowFinancingRoute,
  AppDashboardFlowHighlightsRoute: AppDashboardFlowHighlightsRoute,
  AppDashboardFlowInvestmentRoute: AppDashboardFlowInvestmentRoute,
  AppDashboardFlowOperationRoute: AppDashboardFlowOperationRoute,
}

const AppDashboardFlowRouteWithChildren =
  AppDashboardFlowRoute._addFileChildren(AppDashboardFlowRouteChildren)

interface AppDashboardMetricsRouteChildren {
  AppDashboardMetricsEfficiencyRoute: typeof AppDashboardMetricsEfficiencyRoute
  AppDashboardMetricsGrowthRoute: typeof AppDashboardMetricsGrowthRoute
  AppDashboardMetricsHighlightsRoute: typeof AppDashboardMetricsHighlightsRoute
  AppDashboardMetricsLiquidityRoute: typeof AppDashboardMetricsLiquidityRoute
  AppDashboardMetricsManagementRoute: typeof AppDashboardMetricsManagementRoute
  AppDashboardMetricsMarginRoute: typeof AppDashboardMetricsMarginRoute
  AppDashboardMetricsReturnRoute: typeof AppDashboardMetricsReturnRoute
  AppDashboardMetricsSolvencyRoute: typeof AppDashboardMetricsSolvencyRoute
  AppDashboardMetricsStabilityRoute: typeof AppDashboardMetricsStabilityRoute
}

const AppDashboardMetricsRouteChildren: AppDashboardMetricsRouteChildren = {
  AppDashboardMetricsEfficiencyRoute: AppDashboardMetricsEfficiencyRoute,
  AppDashboardMetricsGrowthRoute: AppDashboardMetricsGrowthRoute,
  AppDashboardMetricsHighlightsRoute: AppDashboardMetricsHighlightsRoute,
  AppDashboardMetricsLiquidityRoute: AppDashboardMetricsLiquidityRoute,
  AppDashboardMetricsManagementRoute: AppDashboardMetricsManagementRoute,
  AppDashboardMetricsMarginRoute: AppDashboardMetricsMarginRoute,
  AppDashboardMetricsReturnRoute: AppDashboardMetricsReturnRoute,
  AppDashboardMetricsSolvencyRoute: AppDashboardMetricsSolvencyRoute,
  AppDashboardMetricsStabilityRoute: AppDashboardMetricsStabilityRoute,
}

const AppDashboardMetricsRouteWithChildren =
  AppDashboardMetricsRoute._addFileChildren(AppDashboardMetricsRouteChildren)

interface AppDashboardResultsCostRouteChildren {
  AppDashboardResultsCostIndexRoute: typeof AppDashboardResultsCostIndexRoute
  AppDashboardResultsCostCategoryDetailRoute: typeof AppDashboardResultsCostCategoryDetailRoute
}

const AppDashboardResultsCostRouteChildren: AppDashboardResultsCostRouteChildren =
  {
    AppDashboardResultsCostIndexRoute: AppDashboardResultsCostIndexRoute,
    AppDashboardResultsCostCategoryDetailRoute:
      AppDashboardResultsCostCategoryDetailRoute,
  }

const AppDashboardResultsCostRouteWithChildren =
  AppDashboardResultsCostRoute._addFileChildren(
    AppDashboardResultsCostRouteChildren,
  )

interface AppDashboardResultsExpenseRouteChildren {
  AppDashboardResultsExpenseIndexRoute: typeof AppDashboardResultsExpenseIndexRoute
  AppDashboardResultsExpenseCategoryDetailRoute: typeof AppDashboardResultsExpenseCategoryDetailRoute
}

const AppDashboardResultsExpenseRouteChildren: AppDashboardResultsExpenseRouteChildren =
  {
    AppDashboardResultsExpenseIndexRoute: AppDashboardResultsExpenseIndexRoute,
    AppDashboardResultsExpenseCategoryDetailRoute:
      AppDashboardResultsExpenseCategoryDetailRoute,
  }

const AppDashboardResultsExpenseRouteWithChildren =
  AppDashboardResultsExpenseRoute._addFileChildren(
    AppDashboardResultsExpenseRouteChildren,
  )

interface AppDashboardResultsIncomeRouteChildren {
  AppDashboardResultsIncomeIndexRoute: typeof AppDashboardResultsIncomeIndexRoute
  AppDashboardResultsIncomeCategoryDetailRoute: typeof AppDashboardResultsIncomeCategoryDetailRoute
}

const AppDashboardResultsIncomeRouteChildren: AppDashboardResultsIncomeRouteChildren =
  {
    AppDashboardResultsIncomeIndexRoute: AppDashboardResultsIncomeIndexRoute,
    AppDashboardResultsIncomeCategoryDetailRoute:
      AppDashboardResultsIncomeCategoryDetailRoute,
  }

const AppDashboardResultsIncomeRouteWithChildren =
  AppDashboardResultsIncomeRoute._addFileChildren(
    AppDashboardResultsIncomeRouteChildren,
  )

interface AppDashboardResultsOtherAccountsRouteChildren {
  AppDashboardResultsOtherAccountsIndexRoute: typeof AppDashboardResultsOtherAccountsIndexRoute
  AppDashboardResultsOtherAccountsCategoryDetailRoute: typeof AppDashboardResultsOtherAccountsCategoryDetailRoute
}

const AppDashboardResultsOtherAccountsRouteChildren: AppDashboardResultsOtherAccountsRouteChildren =
  {
    AppDashboardResultsOtherAccountsIndexRoute:
      AppDashboardResultsOtherAccountsIndexRoute,
    AppDashboardResultsOtherAccountsCategoryDetailRoute:
      AppDashboardResultsOtherAccountsCategoryDetailRoute,
  }

const AppDashboardResultsOtherAccountsRouteWithChildren =
  AppDashboardResultsOtherAccountsRoute._addFileChildren(
    AppDashboardResultsOtherAccountsRouteChildren,
  )

interface AppDashboardResultsRouteChildren {
  AppDashboardResultsCostRoute: typeof AppDashboardResultsCostRouteWithChildren
  AppDashboardResultsExpenseRoute: typeof AppDashboardResultsExpenseRouteWithChildren
  AppDashboardResultsHighlightsRoute: typeof AppDashboardResultsHighlightsRoute
  AppDashboardResultsIncomeRoute: typeof AppDashboardResultsIncomeRouteWithChildren
  AppDashboardResultsOtherAccountsRoute: typeof AppDashboardResultsOtherAccountsRouteWithChildren
}

const AppDashboardResultsRouteChildren: AppDashboardResultsRouteChildren = {
  AppDashboardResultsCostRoute: AppDashboardResultsCostRouteWithChildren,
  AppDashboardResultsExpenseRoute: AppDashboardResultsExpenseRouteWithChildren,
  AppDashboardResultsHighlightsRoute: AppDashboardResultsHighlightsRoute,
  AppDashboardResultsIncomeRoute: AppDashboardResultsIncomeRouteWithChildren,
  AppDashboardResultsOtherAccountsRoute:
    AppDashboardResultsOtherAccountsRouteWithChildren,
}

const AppDashboardResultsRouteWithChildren =
  AppDashboardResultsRoute._addFileChildren(AppDashboardResultsRouteChildren)

interface AppRouteChildren {
  AppLivesheetRoute: typeof AppLivesheetRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppAccountCreateRoute: typeof AppAccountCreateRoute
  AppAskMaraRoute: typeof AppAskMaraRoute
  AppDashboardBalanceRoute: typeof AppDashboardBalanceRouteWithChildren
  AppDashboardFlowRoute: typeof AppDashboardFlowRouteWithChildren
  AppDashboardMetricsRoute: typeof AppDashboardMetricsRouteWithChildren
  AppDashboardResultsRoute: typeof AppDashboardResultsRouteWithChildren
  AppDashboardSpotlightBoardRoute: typeof AppDashboardSpotlightBoardRoute
  AppDashboardValuationRoute: typeof AppDashboardValuationRoute
  AppDataIntegrationRoute: typeof AppDataIntegrationRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppLivesheetRoute: AppLivesheetRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppAccountCreateRoute: AppAccountCreateRoute,
  AppAskMaraRoute: AppAskMaraRoute,
  AppDashboardBalanceRoute: AppDashboardBalanceRouteWithChildren,
  AppDashboardFlowRoute: AppDashboardFlowRouteWithChildren,
  AppDashboardMetricsRoute: AppDashboardMetricsRouteWithChildren,
  AppDashboardResultsRoute: AppDashboardResultsRouteWithChildren,
  AppDashboardSpotlightBoardRoute: AppDashboardSpotlightBoardRoute,
  AppDashboardValuationRoute: AppDashboardValuationRoute,
  AppDataIntegrationRoute: AppDataIntegrationRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  SpotlightRoute: SpotlightRoute,
  AuthVerifyRoute: AuthVerifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
